import React, { useState } from 'react';
import { Box, ToggleButtonGroup, ToggleButton, Typography, Skeleton } from '@mui/material';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

const METRICS = [
  { key: 'calls',           label: 'Calls',         color: '#6366f1' },
  { key: 'tokens_in',       label: 'Tokens In',     color: '#38bdf8' },
  { key: 'tokens_out',      label: 'Tokens Out',    color: '#22c55e' },
  { key: 'cost_usd',        label: 'Cost ($)',       color: '#f59e0b' },
  { key: 'avg_latency_ms',  label: 'Avg Latency',   color: '#ec4899' },
  { key: 'error_count',     label: 'Errors',         color: '#ef4444' },
];

export default function AiUsageTimeSeries({ rows, loading }) {
  const [metric, setMetric] = useState('calls');
  const { color } = METRICS.find(m => m.key === metric) || METRICS[0];

  return (
    <Box sx={{ mb: 3 }}>
      <ToggleButtonGroup
        value={metric}
        exclusive
        onChange={(_, v) => v && setMetric(v)}
        size="small"
        sx={{ mb: 1.5 }}
      >
        {METRICS.map(m => (
          <ToggleButton key={m.key} value={m.key}>{m.label}</ToggleButton>
        ))}
      </ToggleButtonGroup>

      {loading
        ? <Skeleton variant="rectangular" height={220} />
        : (
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={rows} margin={{ top: 4, right: 8, left: 0, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#1e293b" />
              <XAxis dataKey="bucket" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip formatter={v => {
                if (metric === 'cost_usd') return `$${Number(v).toFixed(4)}`;
                if (metric === 'avg_latency_ms') return `${Math.round(Number(v)).toLocaleString()} ms`;
                return Number(v).toLocaleString();
              }} />
              <Bar dataKey={metric} fill={color} radius={[2, 2, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        )
      }
    </Box>
  );
}
